export default __webpack_public_path__ + "static/media/troll.bd7189cf.png";